import type { ChecklistItem } from "@/components/ChecklistTable";

/**
 * 정보처리기사 원서 접수 체크리스트 데이터 (2026년 3회).
 *
 * 본문 표(ChecklistTable, jeongcheogi-application.mdx)와 좌측 사이드바 미니 체크리스트
 * (ChecklistMini, ArticleShell)가 **동일한 항목·쿠키를 공유**해야 양방향 동기화가 성립하므로
 * 이 파일에서 단일 관리한다 (pass-rate-data.ts 와 동일한 SSOT 패턴, JCG-2101).
 *
 * 회차가 바뀌면 `APPLICATION_CHECKLIST_COOKIE`(연도-회차)와 일정 문자열을 함께 갱신한다.
 *
 * 3회 실기 원서접수 분할은 큐넷 2026.9.8. 공고, 실기 사전입력 기간과 기사 등급의 접수 초일
 * 14시 시작은 큐넷 「2026년도 정기 기사 제3회 실기시험 수험자 안내」(2026.9.17) 확정값이다.
 */
export const APPLICATION_CHECKLIST_COOKIE = "jeongcheogi-checklist-2026-3";

export const applicationChecklistItems: ChecklistItem[] = [
  {
    id: "pre-registration-written-test",
    task: "필기 원서 사전입력",
    schedule: "7/16(목) 14시 ~ 7/19(일) 23시59분",
    method: "큐넷",
    link: "https://www.q-net.or.kr",
  },
  {
    id: "select-test-center-written-test",
    task: "필기 시험장 정하기",
    schedule: "7/20(월)(원서접수 시작시간 전까지)",
    method: "정처기 시험장 서비스",
    link: "/exam-registration/jcg-test-center",
  },
  {
    id: "final-registration-written-test",
    task: "필기 원서 접수하기",
    schedule: "7/20(월) 10시(지역별로 시작 시간 다름) ~ 7/23(목) 18시까지",
    method: "큐넷",
    link: "https://www.q-net.or.kr",
  },
  {
    id: "qualification-docs",
    task: "응시자격서류 제출",
    schedule: "9/18(금)까지 (온라인 제출은 9/15(화)까지)",
    method: "큐넷 마이페이지",
    link: "https://www.q-net.or.kr",
  },
  {
    id: "pre-registration-practical-test",
    task: "실기 원서 사전입력",
    schedule: "9/17(목) 14시 ~ 9/20(일) 23시59분",
    method: "큐넷",
    link: "https://www.q-net.or.kr",
  },
  {
    id: "select-test-center-practical-test",
    task: "실기 시험장 정하기",
    schedule: "9/21(월) 14시까지(기사 등급 원서접수 시작 전까지)",
    method: "정처기 시험장 서비스",
    link: "/exam-registration/jcg-test-center",
  },
  {
    id: "final-registration-practical-test",
    task: "실기 원서 접수하기",
    schedule: "9/21(월) 14시(기사 등급) ~ 9/23(수) 18시, 9/28(월) 9시 ~ 18시 (추석 분할)",
    method: "큐넷",
    link: "https://www.q-net.or.kr",
  },
];
